module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "full-width": "",
      "max-width": "933"
    },
    model: {
      value: (_vm.imageUploadModal),
      callback: function($$v) {
        _vm.imageUploadModal = $$v
      },
      expression: "imageUploadModal"
    }
  }, [_c('v-card', [_c('v-card-title', [_c('v-flex', [_c('span', {
    staticClass: "titulo-detalhes pl-4  mt-2 mb-2 headline"
  }, [_vm._v("Subir Imagem")])]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.close($event)
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    staticClass: "pl-5 pr-5 mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "logo",
    attrs: {
      "xs12": "",
      "md12": "",
      "pb-3": ""
    }
  }, [(_vm.imgUploadImage) ? _c('div', {
    staticClass: "item-image-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUploadImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "photo-actions"
  }, [_c('div', {
    staticClass: "alter"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v(" Alterar\n                                "), _c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfImage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "remove",
    on: {
      "click": _vm.removeImage
    }
  }, [_c('v-icon', [_vm._v("close")]), _vm._v(" Remover\n                            ")], 1)])]) : [(_vm.shelfedImage !== '') ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.cropperOn) ? _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": "",
      "mr-3": ""
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": _vm.shelfedImage,
      "alt": "",
      "id": "imgToCrop"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "crop-action",
    on: {
      "click": _vm.crop
    }
  }, [_c('v-icon', [_vm._v("done")]), _vm._v(" Recortar\n                            ")], 1)]) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "md3": ""
    }
  }, [_c('div', {
    staticClass: "cropped-box"
  }, [_c('div', {
    staticClass: "crop-preview"
  }, [_c('img', {
    style: (_vm.cropPreviewStyle),
    attrs: {
      "src": _vm.shelfedImage,
      "alt": ""
    }
  })]), _vm._v(" "), (!_vm.cropperOn) ? _c('div', {
    staticClass: "photo-actions"
  }, [_c('div', {
    staticClass: "alter"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v(" Alterar\n                                    "), _c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfImage
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "remove",
    on: {
      "click": _vm.unshelfImage
    }
  }, [_c('v-icon', [_vm._v("close")]), _vm._v(" Remover\n                                ")], 1)]) : _vm._e()])])], 1) : [_c('input', {
    staticClass: "invisible-all",
    attrs: {
      "type": "file",
      "name": "",
      "value": ""
    },
    on: {
      "change": _vm.shelfImage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "item-image-box"
  }, [_c('div', {
    staticClass: "pa-2 noselect foto"
  }, [_c('v-icon', [_vm._v("insert_photo")]), _vm._v("\n                                imagem do item\n                            ")], 1)])]]], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14c9ae1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/painel/itens/imageUpload.vue
// module id = 732
// module chunks = 2